<template>
  <div class="relative flex items-center justify-center w-full aspect-square">
    <img
        v-if="typeof mainMetal  != 'undefined' && mainMetal != ''"
        :alt="$t(pageStr + '.main_metal_background')"
        :src="
          'https://rubin-website-images.s3.eu-central-1.amazonaws.com/assets/backgrounds/' +
          mainMetal +
          '_pos1.webp'
        "
        class="w-full z-10 absolute inset-0"
    />
    <div v-if="false" class="w-full z-10 relative md:max-w-xl m-auto">
      <vue-image-zoomer
          class="w-full z-10 relative"
          :regular="'https://rubin-website-images.s3.eu-central-1.amazonaws.com/conf/engraving/engraving_030_' + mainMetal +'.webp'"
          :regular-webp="'https://rubin-website-images.s3.eu-central-1.amazonaws.com/conf/engraving/engraving_030_' + mainMetal +'.webp'"
          :zoom-webp="'https://rubin-website-images.s3.eu-central-1.amazonaws.com/conf/engraving/engraving_030_' + mainMetal +'.webp'"
          :zoom="'https://rubin-website-images.s3.eu-central-1.amazonaws.com/conf/engraving/engraving_030_' + mainMetal +'.webp'"
          :zoom-amount="3"
          :click-zoom="true"
          img-class="img-fluid"
          :show-message="false"
          :alt="$t(pageStr + '.engraving_preview')">
        <img
            :alt="$t(pageStr + '.engraving_preview')"
            :src="'https://rubin-website-images.s3.eu-central-1.amazonaws.com/conf/engraving/engraving_030_' + mainMetal +'.webp'"
            class="w-full z-10 relative md:max-w-xl m-auto md:p-10"
        />
      </vue-image-zoomer>
    </div>
    <div class="w-full z-10 relative md:max-w-xl m-auto">
      <img
          :alt="$t(pageStr + '.engraving_preview')"
          :src="'https://rubin-website-images.s3.eu-central-1.amazonaws.com/conf/engraving/engraving_030_' + mainMetal +'.webp'"
          class="w-full z-10 relative md:max-w-xl m-auto"
      />
      <div class="absolute inset-0 z-20 w-full h-full flex justify-center items-center">
        <p class="m-auto text-gray-700 overflow-hidden w-4/6 whitespace-nowrap mx-auto relative text-center flex justify-center"
           :style="{
              fontFamily: engravingFont,
              fontSize: fontSize
           }"
        >
          <template v-if="engraving.font == 'FINGERPRINT'">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33" />
            </svg>

          </template>
          {{ engraving.text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, defineProps} from "vue";
import 'vue-image-zoomer/dist/style.css';
import {VueImageZoomer} from "vue-image-zoomer";

const props = defineProps(["engraving", "mainMetal"]);
const pageStr = "components.itemEngraving"

const textLength = computed(() => {
  if (typeof props.engraving.text === 'string') {
    return props.engraving.text.length;
  } else {
    return 0
  }
})

const engravingFont = computed(() => {
  return (props.engraving.font == "HANDWRITING") ? 'Paris': props.engraving.font
})

const cssStroke = "-webkit-text-stroke-width: 0.2px; -webkit-text-stroke-color: #f4f4f4;"

const fontSize = computed(() => {
  const fontSizes: {
    [key: string]: string;
  } = {
    "Amsterdam": (2 - (0.021 * textLength.value)) + "em",
    "Arial": (2 - (0.021 * textLength.value)) + "em",
    "ArialSymbols": (2 - (0.021 * textLength.value)) + "em",
    "AvantGarde": (2 - (0.025 * textLength.value)) + "em",
    "Benguiat": (2 - (0.032 * textLength.value)) + "em",
    "Berlin": (2 - (0.024 * textLength.value)) + "em",
    "BoereTudor": (2 - (0.03 * textLength.value)) + "em",
    "EdwardianScriptITC": (2 - (0.018 * textLength.value)) + "em",
    "EnglischeSchT": (2 - (0.023 * textLength.value)) + "em",
    "English111VivaceBT": (2 - (0.022 * textLength.value)) + "em",
    "FreestyleScript": (2 - (0.015 * textLength.value)) + "em",
    "PalaceScript": (2.5 - (0.015 * textLength.value)) + "em",
    "Genf": (2 - (0.025 * textLength.value)) + "em",
    "Italic": (2 - (0.025 * textLength.value)) + "em",
    "Koeln": (2 - (0.021 * textLength.value)) + "em",
    "LegerD": (2 - (0.033 * textLength.value)) + "em",
    "MonotypeCorsiva": (2 - (0.024 * textLength.value)) + "em",
    "NuptialBT": (2 - (0.021 * textLength.value)) + "em",
    "Oslo": (2 - (0.014 * textLength.value)) + "em",
    "PalatinoLinotype": (2 - (0.03 * textLength.value)) + "em",
    "Paris": (2 - (0.022 * textLength.value)) + "em",
    "ScriptMTBold": (2 - (0.029 * textLength.value)) + "em",
    "SloganD": (2 - (0.025 * textLength.value)) + "em",
    "TimesNewRoman": (2 - (0.028 * textLength.value)) + "em",
    "Vivaldi": (2 - (0.022 * textLength.value)) + "em",
  }

  return fontSizes[engravingFont.value]
})



</script>

<style scoped>

</style>
